import * as E from './errors';
export interface IParametersValidationError {
	message : string;
};
declare global {
	interface Function {
		//Special method
		//Its the typescript compiler itself who defines the implementation
		//throught ts transformer in typescriptCompilerUtil library.
		//Method not available as js method, only ts method
		validateParameters(...x : unknown[]) : IParametersValidationError | null;
	}
};
E.libraryAssert(
	!(Function.prototype.validateParameters),
	'Function.prototype.validateParameters already implemented!'
);
Function.prototype.validateParameters = function() {
	throw E.user('validateParameters methods only available as typescript method AND is not yet shipped!');
};
export const bindingSymbol = Symbol('function.binding');
// Bind implementation that keep context as id and do not create dupplicate
// /!\ Bugged implementation will mess up your javascript engine for the current navigation context
// so do not make errors in this method.
if ('bind' in Function.prototype) {
	const cp    = Function.prototype.bind;
	const cache : WeakMap<
		Function,
		[
			Parameters<Function['bind']>,
			WeakRef<Function>
		][]
	> = new WeakMap;
	Object.assign(Function.prototype, {
		bind(this: Function, ...args: Parameters<Function['bind']>) {
			const thisStore = (
				cache.get(this) ||
				((x) => (cache.set(this, x), x))( [] )
			);
			const binding = thisStore.find(y => (
				(y[0].length === args.length) &&
				y[0].every((v, i) => ((v instanceof WeakRef) ? v.deref() : v) === args[i])
			));
			let fn : Function & { [ bindingSymbol ] : Function };
			if (binding) {
				const ref = binding[1].deref();
				if (ref) {
					return (ref);
				} else {
					fn = cp.call(this, ...args);
					fn[ bindingSymbol ] = this;
					binding[1] = new WeakRef(fn);
				}
			} else {
				fn = cp.call(this, ...args);
				fn[ bindingSymbol ] = this;
				thisStore.push([
					<Parameters<Function['bind']>>args.map(x => (x instanceof Object) ? new WeakRef(x) : x),
					new WeakRef(fn)
				]);
			}
			return (fn);
		}
	});
	{
		const f = (x : number, y : number) => x + y + 2;
		const f1a = f.bind(null, 1);
		const f1b = f.bind(null, 1);
		const f2 = f.bind(null, 2);
		E.libraryAssert(
			(f1a === f1b) && (f1a !== f2),
			'Function.prototype.bind implementation error!'
		);
	}
}
/**
 *
 **/
export function promisifyCallA(fn : Function) {
	return (new Promise((resolve, reject) => {
		try {
			fn(resolve);
		} catch (error) {
			reject(error);
		}
	}));
};
export function interval(fn : Function, interval : number) {
	return (new Promise((resolve, reject) => {
		let intervalId : number | undefined;
		try {
			intervalId = setInterval(() => {
				const result = fn();
				if (result !== undefined) {
					clearInterval(intervalId);
					resolve(result);
				}
			}, interval);
		} catch (error) {
			if (intervalId) {
				clearInterval(intervalId);
			}
			reject(error);
		}
	}));
};
export async function imports(...importsPacks : string[][]) {
	const out = [];
	for (const importsPack of importsPacks) {
		out.push(await Promise.all(
			importsPack.map(async (moduleURL) => await import(/*webpackIgnore: true*/moduleURL))
		));
	}
	return (out);
};
export async function timeout(delay : number) {
	return (await new Promise((resolve, reject) => {
		try {
			setTimeout(resolve, delay);
		} catch (error) {
			reject(error);
		}
	}));
};
